export const block = {
    id: "",
    timestamp: 0,
    height: "",
    previous: "",
};
// default variables
export const blockVars = {
    id: undefined,
};
export const arweaveBlockQuery = {
    name: "block",
    query: block,
    vars: blockVars,
};
//# sourceMappingURL=block.js.map